import { Link, useLocation } from "react-router-dom";
import "./style.css"
import { useSelector } from "react-redux";

import icon_request from '../../assets/friend_request.svg';
import icon_request_w from '../../assets/friend_request_w.svg';

function Nav() {
    const location = useLocation();
    const status = useSelector(state => state.profil.status);
    const request = useSelector(state => state.profil.accessRequest);

    const isActif = (path) => {
        return location.pathname === `/home${path ? `/${path}` : ''}` ? "actif" : "";
    }

    const logout = () => {
        sessionStorage.removeItem('save_login');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('password');
        sessionStorage.removeItem('status');
        sessionStorage.removeItem('token');

        localStorage.removeItem('save_login');
        localStorage.removeItem('email');
        localStorage.removeItem('password');
        localStorage.removeItem('status');
        localStorage.removeItem('token');

        window.location.reload();
    }

    return (
        <nav>
            <ul>
                {status === 'admin' &&
                    <li className={isActif('wlist')}>
                        <Link to="wlist">Email autorisé</Link>
                    </li>
                }
                <li className={isActif('')}>
                    <Link to="">Rechercher</Link>
                </li>
                <li className={isActif('profil')}>
                    <Link to="profil">Mon profil</Link>
                </li>
                <li className={isActif('access')}>
                    <Link to="access">Accessibilité</Link>
                    {request && request.length !== 0 && <img src={!isActif('access') ? icon_request : icon_request_w} alt="" />}
                </li>
                <li className={isActif('meeting')}>
                    <Link to="meeting">Conférences</Link>
                </li>
                <li>
                    <button onClick={() => logout()}>Se déconnecter</button>
                </li>
            </ul>
        </nav>
    )
}

export default Nav;